import {
  getPersonalDataTableRevoke,
  getPersonalDataTableSubmit,
} from '~/store/processing-personal/thunks/personalDataTableThunks.ts';
import { getDecryptedCookieValue as getSavedDecryptedCookieValue } from '~/helpers/cookieCrypto.ts';
import { ManagerRole } from '~/constants/clientTypes.ts';
import { IdentificationType } from '~/modules/identification/forms/GettingStarted/types';

type RedirectAfterSignInParams = {
  groups?: string[] | null;
  currentToken?: string | null;
  resolvedRedirect?: string;
  dispatch: (...args: unknown[]) => unknown;
  navigate: (path: string, options: { replace: boolean }) => void;
};

export const getDecryptedCookieValue = (cookieName: string): string =>
  getSavedDecryptedCookieValue(cookieName, { removeOnError: true }) || '';

export const redirectAfterSignIn = ({
  groups,
  resolvedRedirect,
  dispatch,
  navigate,
}: RedirectAfterSignInParams): void => {
  const normalizedGroups = Array.isArray(groups) ? groups : [];

  if (resolvedRedirect) {
    navigate(resolvedRedirect, { replace: true });
    return;
  }

  if (normalizedGroups.length !== 1) {
    navigate('/services', { replace: true });
    return;
  }

  const group = normalizedGroups[0] as ManagerRole;

  if ([ManagerRole.observer, ManagerRole.call_center_operator].includes(group)) {
    navigate('/application-reports', { replace: true });
    return;
  }

  if (group === ManagerRole.manager) {
    navigate(`/identification/questionnaire?type=${IdentificationType.PRIMARY}`, { replace: true });
    return;
  }

  if ([ManagerRole.personal_data_manager, ManagerRole.call_center_operator].includes(group)) {
    const data = { page: 0, size: 50 };
    dispatch(getPersonalDataTableSubmit({ data }));
    dispatch(getPersonalDataTableRevoke({ data }));
    navigate('/personal-data-table', { replace: true });
    return;
  }

  navigate('/services', { replace: true });
};
